<template>
  <div>
    <!-- 查询搜索栏 -->
    <el-row :gutter="10" style="margin-bottom:15px;">
      <el-col :span="8">
        <el-input v-model="queryAppId" clearable placeholder="输入APP ID进行查询/搜索" />
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getList">查询搜索</el-button>
      </el-col>
      <el-col :span="12">
        <el-button type="success" @click="addShow = true">新增APP</el-button>
      </el-col>
    </el-row>

    <!-- APP列表 -->
    <el-table :data="list" border style="width:100%;">
      <el-table-column prop="appId" label="APP ID" />
      <el-table-column prop="app_name" label="APP名称" />
      <el-table-column prop="layout" label="布局方式">
        <template #default="{row}">
          <span>{{ row.layout === 1 ? '瀑布流布局' : '列表布局' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="layout_type" label="排列方式">
        <template #default="{row}">
          <!-- <span>{{ row.layout === 1 ? '瀑布流布局' : '列表布局' }}</span> -->
          <span v-if="row.layout_type === 1">上图下文</span>
          <span v-if="row.layout_type === 2">左图右文</span>
          <span v-if="row.layout_type === 3">左文右图</span>
          <span v-if="row.layout_type === 4">上文下图</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="{row}">
          <el-button @click="openEdit(row)">修改</el-button>
          <el-button type="danger" @click="deleteApp(row.appId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      :current-page.sync="pageNum"
      :page-size.sync="pageSize"
      :total="total"
      style="margin-top:20px;text-align:right;"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="getList"
      @current-change="getList"
    />

    <!-- 新增弹窗 -->
    <el-dialog title="新增APP" :visible.sync="addShow">
      <el-form :model="form">
        <el-form-item label="APP ID">
          <el-input v-model="form.appId" placeholder="请输入唯一APP ID" />
        </el-form-item>
        <el-form-item label="APP名称">
          <el-input v-model="form.app_name" placeholder="请输入APP名称" />
        </el-form-item>
        <el-form-item label="布局方式">
          <el-select v-model="form.layout" placeholder="请选择布局" style="width:100%">
            <el-option label="列表布局" :value="0"></el-option>
            <el-option label="瀑布流布局" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <!-- 列表布局才显示 -->
        <el-form-item label="列表布局样式" v-if="form.layout === 0">
          <el-select v-model="form.layout_type" style="width:100%">
            <el-option label="上图下文" :value="1"></el-option>
            <el-option label="左图右文" :value="2"></el-option>
            <el-option label="左文右图" :value="3"></el-option>
            <el-option label="上文下图" :value="4"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer">
        <el-button @click="addShow = false">取消</el-button>
        <el-button type="primary" @click="addApp">确定新增</el-button>
      </div>
    </el-dialog>

    <!-- 修改弹窗 -->
    <el-dialog title="修改APP" :visible.sync="editShow">
      <el-form :model="form">
        <el-form-item label="APP名称">
          <el-input v-model="form.app_name" />
        </el-form-item>
        <el-form-item label="布局方式">
          <el-select v-model="form.layout" placeholder="请选择布局" style="width:100%">
            <el-option label="列表布局" :value="0"></el-option>
            <el-option label="瀑布流布局" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <!-- 列表布局才显示 -->
        <el-form-item label="列表布局样式" v-if="form.layout === 0">
          <el-select v-model="form.layout_type" style="width:100%">
            <el-option label="上图下文" :value="1"></el-option>
            <el-option label="左图右文" :value="2"></el-option>
            <el-option label="左文右图" :value="3"></el-option>
            <el-option label="上文下图" :value="4"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer">
        <el-button @click="editShow = false">取消</el-button>
        <el-button type="primary" @click="editApp">确定修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import req from '@/api/request'
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      queryAppId: '',
      addShow: false,
      editShow: false,
      form: {
        appId: '',
        app_name: '',
        layout: 0,
        layout_type: 1  // 默认上图下文
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await req.get('/admin/app/listPage', {
        params: {
          appId: this.queryAppId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })
      this.list = res.data?.list || []
      this.total = res.data?.total || 0
    },

    // 新增
    async addApp() {
      await req.post('/admin/app/add', this.form)
      this.$message.success('新增成功')
      this.addShow = false
      this.getList()
    },

    // 修改
    openEdit(row) {
      this.form = { ...row }
      this.editShow = true
    },
    async editApp() {
      await req.post('/admin/app/edit', this.form)
      this.$message.success('修改成功')
      this.editShow = false
      this.getList()
    },

    // 删除
    async deleteApp(appId) {
      await req.post('/admin/app/del', { appId })
      this.$message.success('删除成功')
      this.getList()
    }
  }
}
</script>